import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

import "./accordion.css";
import Link from "./link";


export default function Accordion(props){
    const [isActive, setActive] = useState(false);
    const [data, setData] = useState(props.data);

    const [files, setFiles] = useState(props.files);

    const filesFiltered = files.filter(x => {return x.safety_policies_id === props.id});

    const [titles, setTitles] = useState();


    function handleChange(){
        if(isActive) {
            setActive(false);
        } else setActive(true);
    }
    return (
        <div className="accordion"> 
        
            <div className="title" onClick={handleChange}> 
                {isActive? <FontAwesomeIcon  icon={faMinus}/> : <FontAwesomeIcon  icon={faPlus}/>} <span className="space" > | </span> <span> {props.name} </span>
            </div>

            {isActive? 
            <div className="content"> 
                {filesFiltered.map(({directus_files_id}) => { 
                    return (
                    <Link key={directus_files_id} fileID={directus_files_id}/>
                )
                })}
            </div> 
            : null}
        </div>
    )
}